import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';

// Import main CSS
import 'css/main.css';

// Import the App component
import { App } from 'app';

// Import store
import { store } from 'core/store/configureStore';

// Import error boundary
import { ChunkErrorBoundary } from 'app/components/ChunkErrorBoundary';

// Initialize memory monitoring
//import 'utils/iosMemoryMonitor';
//import memoryLeakChecker from 'utils/memoryLeakChecklist';

const MOUNT_NODE = document.getElementById('root') as HTMLElement;

if (MOUNT_NODE) {
  const root = createRoot(MOUNT_NODE);

  root.render(
    <Provider store={store}>
      <HelmetProvider>
        <ChunkErrorBoundary>
          <App />
        </ChunkErrorBoundary>
      </HelmetProvider>
    </Provider>,
  );
} else {
  console.error('Root element not found');
}
